import { Typography } from '@mui/material'

const CustomCheckBox = ({
  id,
  label,
  onChange,
  value,
  error,
  errorMsg,
}: {
  id: string
  label: any
  onChange: any
  value: boolean
  error?: any
  errorMsg?: string
}) => {
  return (
    <>
      <input id={id} type="checkbox" onChange={onChange} checked={value} />
      <label htmlFor={id}>
        <span></span>
        {label}
      </label>
      {error && (
        <Typography color="error" variant="caption">
          {errorMsg}
        </Typography>
      )}
    </>
  )
}

export default CustomCheckBox
